import type { Role } from '@/entities/auth';

export const ROUTES = {
  HOME: '/',
  UNIFIED_SEARCH: '/search',
  DAG: '/dag',
  DAG_DETAIL: '/dag-detail',
  EXPERIMENTS: '/experiments',
  EXPERIMENT_WORKBENCH: '/experiments/workbench/:runId',
  DOMAIN: '/domain',
  ASSET_EXPLORER: '/assets',
  DATA_QUALITY: '/quality',
  GLOSSARY: '/glossary',
  TAGS: '/tags',
  TAGS_DETAIL: '/tags/detail',
  LINEAGE: '/lineage',
  CONNECTORS: '/connectors',
  ADMIN_SETTINGS: '/admin',
  ADMIN_MONITORING: '/admin/monitoring',
  ADMIN_PERFORMANCE: '/admin/performance',
  LOGIN: '/login',
  UNAUTHORIZED: '/unauthorized',
} as const;

export const ROUTE_LABELS = {
  [ROUTES.HOME]: '홈',
  [ROUTES.UNIFIED_SEARCH]: '통합 검색',
  [ROUTES.DAG]: 'DAG',
  [ROUTES.EXPERIMENTS]: '실험',
  [ROUTES.EXPERIMENT_WORKBENCH]: '실험 워크벤치',
  [ROUTES.DOMAIN]: '도메인',
  [ROUTES.GLOSSARY]: '용어',
  [ROUTES.TAGS]: '태그',
  [ROUTES.LINEAGE]: '계보',
  [ROUTES.CONNECTORS]: '커넥터',
  [ROUTES.ADMIN_SETTINGS]: '관리자 설정',
  [ROUTES.ADMIN_MONITORING]: '시스템 모니터링',
  [ROUTES.ADMIN_PERFORMANCE]: '성능 모니터링',
} as const;

export const ROUTE_PERMISSIONS = {
  AUTHENTICATED: ['admin', 'manager', 'user', 'demo', 'default-roles'] as Role[],
  ADMIN_AND_MANAGER: ['admin', 'manager'] as Role[],
  ADMIN_ONLY: ['admin'] as Role[],
} as const;
